<div id="iframe-portalV1">
  <div class="layout-main">
    <div class="container-fluid">
      <nav class="navbar navbar-expand navbar-light bg-light mb-3" id="breadcrumb-sf-1">
        <nav aria-label="breadcrumb" class="navbar-nav mr-auto">
          <ol class="breadcrumb ol-sf-1">
            <li class="breadcrumb-item">
              <a *roles="['ROLE_MCKAY']" routerLink="/mckay/{{getUserCurrent().company.uniqid}}">Home</a>
              <a *roles="['ROLE_CLIENT']" routerLink="/client/{{getUserCurrent().company.uniqid}}">Home</a>
            </li>
            <li aria-current="page" class="breadcrumb-item active text-dark">
              Request PLR/lat historical data
            </li>
          </ol>
        </nav>
      </nav>
      <div class="pb-2 mb-3 border-bottom">
        <h3>
          <b>Request PLR/lat historical data</b>
        </h3>
      </div>
      <div class="alert alert-primary">
        <strong>This form is used to request historical data of your Bandwidth service.</strong><br>
        <strong>Day 1 data are extracted from Latency Monitor's logs at 00:10 UTC on Day 2.</strong><br><br>
        <strong>Historical data</strong> is a minute log of the observed PLR % value on a given circuit.<br>
        The log format is a 3 column CSV (datetime start minute, latency_value, PLR_value)
        labeled "ts (GMT)", "srcPOP_to_destPOP_latency (ms)", "srcPOP_to_destPOP_plr (%)".<br>
        Value are typically median values of observed samples within a minute.<br>
        You will be notified of the file availability by email. Please expect a slight delay.<br>
      </div>
      <div *ngIf="requestIsBeingProcessedAlertMessage" class="alert alert-success" role="alert">
        Your request is being processed. You will receive an email when the data is available for download.
      </div>
      <div *ngIf="requestError" class="alert alert-danger" role="alert">
        We are unable to process your request, please try again later.
      </div>
      <form #historyRequestForm="ngForm" (ngSubmit)="onSubmit(historyRequestForm)">
        <div class="row">
          <div class="form-group col-8">
            <p-floatLabel>
              <p-calendar #startDate="ngModel" [(ngModel)]="requestHistoricalData.start" [showIcon]="true" [minDate]="minStartDate" [maxDate]="maxStartDate"
                          [showTime]="true" hourFormat="12" name="startDate" dateFormat="dd/mm/yy" required (ngModelChange)="changeStartDate()"></p-calendar>
              <label> Start </label>
            </p-floatLabel>
            <small *ngIf="(historyRequestForm.submitted || startDate.dirty || startDate.touched)">
              <p *ngIf="startDate?.errors?.required" class="error-text">
                please select start date.
              </p>
            </small>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-8">
            <p-floatLabel>
              <p-calendar #stopDate="ngModel" [(ngModel)]="requestHistoricalData.stop" [showIcon]="true" [minDate]="minEndDate" [maxDate]="maxEndDate"
                          [showTime]="true" hourFormat="12" name="stopDate" dateFormat="dd/mm/yy" required (ngModelChange)="changeEndDate()"></p-calendar>
              <label> Stop </label>
            </p-floatLabel>
            <small *ngIf="(historyRequestForm.submitted || stopDate.dirty || stopDate.touched)">
              <p *ngIf="stopDate?.errors?.required" class="error-text">
                please select stop date.
              </p>
            </small>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-8">
            <p-floatLabel>
              <p-dropdown [(ngModel)]="requestHistoricalData.timezone" [options]="timeZonesItems"
                          name="timezone"></p-dropdown>
              <label> Timezone </label>
            </p-floatLabel>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-8">
            <p-floatLabel>
              <p-dropdown [(ngModel)]="requestHistoricalData.connectionPointId" (onChange)="initializePopItems($event.value)"
                          [options]="etreeItems"></p-dropdown>
              <label> E-Trees </label>
            </p-floatLabel>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-8">
            <p-floatLabel>
              <p-dropdown [(ngModel)]="requestHistoricalData.listeningPop" [options]="popItems"
                          name="pop"></p-dropdown>
              <label> POP </label>
            </p-floatLabel>
          </div>
        </div>
        <div class="d-flex justify-content-end buttons-margin-left">
          <button [disabled]="loading" class="btn btn-outline-primary" id="add_user_button" type="submit">
            Send request
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
